<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Formulário
      <router-link slot="right" to="/" class="button"> Dashboard </router-link>
    </hero-bar>
    <section class="section is-main-section">
      <form @submit.prevent="formAction" class="box">
        <card-component :title="title" icon="ballot">
          <div
            v-if="$route.params.id"
            class="is-flex is-flex-wrap-wrap is-justify-content-space-between is-align-items-center"
          >
            <div class="mb-2 mr-4">
              <strong>Status:</strong>
              <StatusTag :status="form.dispositivo.status" class="ml-2" />
            </div>

            <div
              v-if="
                hasPermitionToApprove() &&
                form.dispositivo.status === 'PENDENTE'
              "
              class="is-flex is-align-items-center mb-2"
            >
              <ApproveOrRefuseGroupButtons
                @refuse="(payload) => recusar(payload)"
                @approve="aprovar"
              />
            </div>
            <b-button
              v-if="canBlock"
              type="is-danger"
              icon-left="lock"
              class="ml-2"
              @click="bloquear"
            >
              Bloquear
            </b-button>
            <b-button
              v-if="canUnblock"
              type="is-success"
              icon-left="lock-open"
              @click="desbloquear"
            >
              Desbloquear
            </b-button>
          </div>
          <!-- <div>
            <div
              class="is-flex is-flex-wrap-wrap is-justify-content-space-between is-align-items-center is-flex-direction-column-mobile is-flex-direction-row"
            >
              <strong class="mb-2 mr-4">
                Campos marcados com * são considerados obrigatórios
              </strong>

              <div v-if="$route.params.id" class="mb-2 mr-4">
                <strong>Status:</strong>
                <StatusTag :status="form.dispositivo.status" class="ml-2" />
              </div>

              <div
                v-if="$route.params.id && hasPermitionToApprove()"
                class="is-flex is-align-items-center mb-2"
              >
                <ApproveOrRefuseGroupButtons
                  @refuse="(payload) => recusar(payload)"
                  @approve="aprovar"
                />
              </div>
            </div>
          </div> -->
          <b-field horizontal>
            <b-radio
              v-model="form.dispositivo.tipoAcessoDispositivo"
              name="tipoDispositivo"
              native-value="PESSOAL"
              :disabled="isEdit"
            >
              Pessoal
            </b-radio>

            <b-radio
              v-model="form.dispositivo.tipoAcessoDispositivo"
              name="tipoDispositivo"
              native-value="CORPORATIVO"
              :disabled="isEdit"
            >
              Corporativo
            </b-radio>
          </b-field>

          <b-field horizontal>
            <b-field
              label="Nome *"
              v-if="form.dispositivo.tipoAcessoDispositivo === 'PESSOAL'"
            >
              <b-autocomplete
                v-model="nomePessoaBusca"
                :data="acessosPessoas"
                field="pessoa.nome"
                placeholder="Digite o nome da pessoa"
                icon="account-search"
                expanded
                :loading="isBuscandoPessoas"
                :disabled="isEdit"
                @typing="buscarPessoas"
                @select="selecionarPessoa"
              >
                <template #empty> Nenhuma pessoa encontrada. </template>

                <template #default="props">
                  {{ props.option.pessoa.nome }}
                </template>
              </b-autocomplete>
            </b-field>

            <!-- <b-field
              label="CPF *"
              v-if="form.dispositivo.tipoAcessoDispositivo === 'PESSOAL'"
            >
              <b-input
                type="number"
                v-model="form.dispositivo.cpf"
                icon="doc"
                placeholder="Digite o CPF*"
                name="cpf"
                required
              >
              </b-input>
            </b-field> -->
            <b-field label="Empresa *">
              <b-select
                v-model="form.dispositivo.empresaId"
                placeholder="Selecione uma Empresa*"
                required
                :disabled="isEdit"
                data-js="empresa"
              >
                <option
                  v-for="empresa in getEmpresas"
                  :key="empresa.id"
                  :value="empresa.id"
                >
                  {{ empresa.razaoSocial }}
                </option>
              </b-select>
            </b-field>
          </b-field>

          <b-field horizontal>
            <b-field label="Tipo de dispositivo *">
              <b-select
                v-model="form.dispositivo.tipoDispositivo"
                placeholder="Selecione o tipo de dispositivo"
                expanded
                required
                :disabled="isEdit"
              >
                <option
                  v-for="tipo in tipoDispositivos"
                  :key="tipo.value"
                  :value="tipo.value"
                >
                  {{ tipo.label }}
                </option>
              </b-select>
            </b-field>
            <b-field
              label="Setor"
              v-if="form.dispositivo.tipoAcessoDispositivo === 'PESSOAL'"
            >
              <b-input
                v-model="form.dispositivo.setor"
                placeholder="Digite o Setor*"
                name="setor"
                :disabled="isEdit"
              />
            </b-field>

            <b-field
              label="Cargo"
              v-if="form.dispositivo.tipoAcessoDispositivo === 'PESSOAL'"
            >
              <b-input
                v-model="form.dispositivo.cargo"
                placeholder="Digite o Cargo*"
                name="cargo"
                :disabled="isEdit"
              />
            </b-field>
            <b-field label="Celular de contato">
              <b-input
                v-model="form.dispositivo.celularContato"
                placeholder="Digite o celular"
                name="celularContato"
                :disabled="isEdit"
              />
            </b-field>
          </b-field>

          <b-field horizontal>
            <b-field label="Modelo *">
              <b-input
                v-model="form.dispositivo.modelo"
                icon="model"
                placeholder="Modelo do aparelho"
                name="modelo"
                required
                :disabled="isEdit"
              >
              </b-input>
            </b-field>
            <b-field label="Cor *">
              <b-input
                v-model="form.dispositivo.cor"
                icon="color"
                placeholder="Cor de aparelho"
                name="cor"
                required
                :disabled="isEdit"
              >
              </b-input>
            </b-field>
            <b-field label="Marca *">
              <b-input
                v-model="form.dispositivo.marca"
                icon="person"
                placeholder="Marca do aparelho"
                name="marca"
                required
                :disabled="isEdit"
              >
              </b-input>
            </b-field>

            <b-field label="Data de expiração *" v-if="$route.params.id">
              <b-datepicker
                @icon-right-click="clearDate"
                v-model="form.dispositivo.dataVencimento"
                :disabled="isEdit"
              >
              </b-datepicker>
            </b-field>
          </b-field>
          <!-- Justificativa -->
          <b-field label="Justificativa *" horizontal>
            <b-input
              type="textarea"
              v-model="form.dispositivo.justificativa"
              maxlength="200"
              placeholder="Justificativa para autorização"
              required
              :disabled="isEdit"
            ></b-input>
          </b-field>

          <b-field horizontal>
            <div class="control">
              <b-button
                native-type="submit"
                type="is-info"
                :loading="isLoading"
                v-if="!this.$route.params.id"
              >
                Salvar
              </b-button>
            </div>
          </b-field>
          <div v-if="qrCode" class="has-text-centered mt-5">
            <p class="mb-3">QR Code gerado</p>

            <img
              :src="qrCode"
              alt="QR Code de autorização"
              style="max-width: 300px"
            />
          </div>
        </card-component>
      </form>
    </section>

    <section>
      <card-component>
        <ListDocumentosDispositivos
          v-if="$route.params.id"
          :dispositivo-id="Number($route.params.id)"
        />
      </card-component>
    </section>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import CheckboxRadioPicker from "@/components/CheckboxRadioPicker.vue";
import HeroBar from "@/components/HeroBar.vue";
import CardComponent from "@/components/Cards/CardComponent.vue";
import TitleBar from "@/components/TitleBar.vue";
import DispositivosService from "@/services/DispositivosService";
import AcessosService from "@/services/AcessosService";
import StatusTag from "@/components/StatusTag.vue";
import ApproveOrRefuseGroupButtons from "@/components/ApproveOrRefuseGroupButtons.vue";
import Util from "@/services/Util";
import QRCode from "qrcode";
import ListDocumentosDispositivos from "./ListDocumentosDispositivos.vue";

export default defineComponent({
  name: "FormDispositivos",

  components: {
    CheckboxRadioPicker,
    HeroBar,
    CardComponent,
    TitleBar,
    StatusTag,
    ApproveOrRefuseGroupButtons,
    ListDocumentosDispositivos,
  },

  data() {
    return {
      isLoading: false,
      empresas: [],
      ativo: false,
      qrCode: null,
      tokenQRCode: null,
      acessosPessoas: [],
      nomePessoaBusca: "",
      isBuscandoPessoas: false,
      timerBuscaPessoa: null,

      titleStack: [
        "SECAPI",
        "Dispositivos",
        this.$route.params.id ? "Alterar Dispositivo" : "Adicionar Dispositivo",
      ],

      title: this.$route.params.id
        ? "Alterar Dispositivo"
        : "Adicionar Dispositivo",

      tipoDispositivos: [
        {
          value: "TABLET",
          label: "Tablet",
        },
        {
          value: "CELULAR",
          label: "Celular",
        },
        {
          value: "EQUIPAMENTO_ELETRONICO",
          label: "Equipamento eletrônico",
        },
      ],

      form: {
        dispositivo: {
          acessoPessoaId: null,
          tipoAcessoDispositivo: null,
          tipoDispositivo: null,
          empresaId: null,
          celularContato: null,
          marca: null,
          modelo: null,
          cor: null,
          justificativa: null,
          setor: null,
          cargo: null,
          status: null,
          dataVencimento: null,
        },
      },
    };
  },

  mounted() {
    this.$http
      .get(`/empresas?page=0&size=1000&orderBy=razaoSocial,ASC`)
      .then((response) => {
        this.empresas = response.data.content;
      });

    if (this.$route.params.id) {
      this.getDispositivo(this.$route.params.id);
    }

    AcessosService.getAcessos(0, {
      size: 15000,
      status: "ATIVO",
    })
      .then((response) => {
        console.log("TOTAL:", response.data.totalElements);
        console.log("PÁGINAS:", response.data.totalPages);
        console.log("RECEBIDOS:", response.data.content.length);

        this.acessosPessoas = response.data.content;
      })
      .catch((error) => {
        console.error("ERRO AO BUSCAR ACESSOS:", error);
      });
  },
  methods: {
    buscarPessoas(nome) {
      clearTimeout(this.timerBuscaPessoa);

      if (!nome || nome.trim().length < 3) {
        this.acessosPessoas = [];
        return;
      }

      this.timerBuscaPessoa = setTimeout(async () => {
        this.isBuscandoPessoas = true;

        try {
          const response = await AcessosService.getAcessos(0, {
            nome: nome.trim(),
            size: 20,
            status: "ATIVO",
          });

          this.acessosPessoas = response.data.content || [];
        } catch (error) {
          console.error("Erro ao buscar pessoas:", error);
          this.acessosPessoas = [];
        } finally {
          this.isBuscandoPessoas = false;
        }
      }, 500);
    },

    selecionarPessoa(acesso) {
      if (!acesso) {
        this.form.dispositivo.acessoPessoaId = null;
        return;
      }

      this.form.dispositivo.acessoPessoaId = acesso.id;
      this.nomePessoaBusca = acesso.pessoa.nome;

      console.log("PESSOA SELECIONADA:", acesso);
      console.log("ID ACESSO PESSOA:", this.form.dispositivo.acessoPessoaId);
    },
    documentacaoPendente(dispositivo) {
      return dispositivo.status === "DOCUMENTACAO_PENDENTE";
    },
    hasPermitionToBlock() {
      return Util.isAdmin();
    },
    canApprove() {
      return (
        this.hasPermitionToApprove() &&
        this.form.dispositivo.status === "PENDENTE"
      );
    },
    async aprovar() {
      try {
        const id = this.form.dispositivo.id;

        // 1. Autoriza a solicitação
        await DispositivosService.autorizarDispositivo(id);

        // 2. Busca o token gerado pelo backend
        const responseToken = await DispositivosService.getTokenDispositivo(id);

        console.log("RESPOSTA TOKEN:", responseToken);
        console.log("DADOS DO TOKEN:", responseToken.data);

        const token = responseToken.data.token;

        if (!token) {
          throw new Error("Token não foi retornado pelo backend.");
        }

        console.log("TOKEN RECEBIDO:", token);

        this.tokenQRCode = token;

        this.form.dispositivo.status = "APROVADO";

        this.$buefy.toast.open({
          message: "Dispositivo aprovado com sucesso!",
          position: "is-bottom",
          type: "is-success",
        });
      } catch (error) {
        console.error("Erro ao aprovar dispositivo:", error);

        this.$buefy.toast.open({
          message:
            error.response?.data?.message ??
            error.message ??
            "Erro ao aprovar dispositivo.",
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    async gerarQRCode(token) {
      try {
        this.qrCode = await QRCode.toDataURL(token, {
          width: 300,
          margin: 2,
        });

        console.log("TOKEN:", token);
        console.log("QR CODE GERADO:", this.qrCode);
      } catch (error) {
        console.error("Erro ao gerar QR Code:", error);

        this.$buefy.toast.open({
          message: "Erro ao gerar QR Code.",
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },

    async recusar(payload) {
      try {
        const { motivoRecusa } = payload;
        const id = this.form.dispositivo.id;

        console.log("RECUSANDO DISPOSITIVO:", id);
        console.log("MOTIVO DA RECUSA:", motivoRecusa);

        await DispositivosService.negarDispositivo(id);

        this.form.dispositivo.status = "RECUSADO";

        this.$buefy.toast.open({
          message: "Dispositivo recusado com sucesso!",
          position: "is-bottom",
          type: "is-success",
        });
      } catch (error) {
        console.error("Erro ao recusar dispositivo:", error);

        this.$buefy.toast.open({
          message:
            error.response?.data?.message ?? "Erro ao recusar dispositivo.",
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },

    async bloquear() {
      try {
        const id = this.form.dispositivo.id;

        console.log("BLOQUEANDO DISPOSITIVO:", id);

        await DispositivosService.bloquearDispositivo(id);

        this.form.dispositivo.status = "BLOQUEADO";

        this.$buefy.toast.open({
          message: "Dispositivo bloqueado com sucesso!",
          position: "is-bottom",
          type: "is-success",
        });
      } catch (error) {
        console.error("Erro ao bloquear dispositivo:", error);

        this.$buefy.toast.open({
          message:
            error.response?.data?.message ?? "Erro ao bloquear dispositivo.",
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    async desbloquear() {
      try {
        const id = this.form.dispositivo.id;

        console.log("DESBLOQUEANDO DISPOSITIVO:", id);

        await DispositivosService.autorizarDispositivo(id);

        this.form.dispositivo.status = "APROVADO";

        this.$buefy.toast.open({
          message: "Dispositivo desbloqueado com sucesso!",
          position: "is-bottom",
          type: "is-success",
        });
      } catch (error) {
        console.error("Erro ao desbloquear dispositivo:", error);

        this.$buefy.toast.open({
          message:
            error.response?.data?.message ?? "Erro ao desbloquear dispositivo.",
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },

    hasPermitionToApprove() {
      return Util.isAdmin();
    },
    formAction() {
      this.isLoading = true;

      // EDIÇÃO
      // if (this.form.dispositivo.id) {
      //   DispositivosService.putDispositivo(
      //     this.form.dispositivo.id,
      //     this.form.dispositivo
      //   )
      //     .then((response) => {
      //       this.$buefy.toast.open({
      //         message: "Dispositivo atualizado com sucesso!",
      //         position: "is-bottom",
      //         type: "is-success",
      //       });

      //       this.voltar();
      //     })
      //     .catch((error) => {
      //       console.error("Erro ao atualizar dispositivo:", error);

      //       this.$buefy.toast.open({
      //         message:
      //           error.response?.data?.message ||
      //           "Erro ao atualizar dispositivo!",
      //         position: "is-bottom",
      //         type: "is-danger",
      //       });
      //     })
      //     .finally(() => {
      //       this.isLoading = false;
      //     });

      //   return;
      // }

      if (
        this.form.dispositivo.tipoAcessoDispositivo === "PESSOAL" &&
        !this.form.dispositivo.acessoPessoaId
      ) {
        this.$buefy.toast.open({
          message: "Selecione uma pessoa. Caso não esteja listada, verifique se possui cadastro ativo em Acesso Pessoa.",
          position: "is-bottom",
          type: "is-danger",
        });

        this.isLoading = false;
        return;
      }
      DispositivosService.postDispositivo(this.form.dispositivo)
        .then((response) => {
          console.log("RESPOSTA DO BACKEND:", response);
          console.log("DADOS RETORNADOS:", response.data);

          const idAcessoDispositivo = response.data.id;

          this.$buefy.toast.open({
            message: "Dispositivo salvo com sucesso!",
            position: "is-bottom",
            type: "is-success",
          });

          this.$router.push({
            name: "DocumentosDispositivo",
            params: {
              id: idAcessoDispositivo,
            },
          });
        })
        .catch((error) => {
          console.error("ERRO AO SALVAR DISPOSITIVO:", error);

          if (error.response) {
            console.error("STATUS:", error.response.status);
            console.error("RESPOSTA:", error.response.data);
          }

          this.$buefy.toast.open({
            message:
              error.response?.data?.message || "Erro ao salvar dispositivo!",
            position: "is-bottom",
            type: "is-danger",
          });
        })

        .finally(() => {
          this.isLoading = false;
        });
    },

    async getDispositivo(id) {
      try {
        const res = await DispositivosService.getDispositivo(id);

        const dispositivo = res.data;
        this.form.dispositivo.status = dispositivo.status;
        Object.assign(this.form.dispositivo, {
          ...dispositivo,
          id: dispositivo.id ?? id,
          acessoPessoaId: dispositivo.acessoPessoaId ?? null,
          tipoAcessoDispositivo: dispositivo.tipoAcessoDispositivo ?? null,
          tipoDispositivo: dispositivo.tipoDispositivo ?? null,
          empresa: dispositivo.empresa ?? null,
          celularContato: dispositivo.celularContato ?? null,
          marca: dispositivo.marca ?? null,
          modelo: dispositivo.modelo ?? null,
          cor: dispositivo.cor ?? null,
          justificativa: dispositivo.justificativa ?? null,
          setor: dispositivo.setor ?? null,
          cargo: dispositivo.cargo ?? null,
          status: dispositivo.status ?? null,
          dataVencimento: dispositivo.dataVencimento
            ? new Date(dispositivo.dataVencimento + "T00:00:00")
            : null,
        });

        if (this.documentacaoPendente(dispositivo)) {
          this.$buefy.toast.open({
            message: "Esta solicitação precisa dos documentos obrigatórios.",
            position: "is-bottom",
            type: "is-warning",
          });

          this.$router.replace({
            name: "DocumentosDispositivo",
            params: {
              id: dispositivo.id ?? id,
            },
          });

          return;
        }
      } catch (error) {
        console.error("Erro ao buscar dispositivo:", error);

        this.$buefy.toast.open({
          message:
            error.response?.data?.message ??
            "Não foi possível carregar o dispositivo.",
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },

    voltar() {
      window.history.back();
    },
  },

  computed: {
    getEmpresas() {
      return this.empresas.map((empresa) => {
        return {
          razaoSocial: empresa.razaoSocial,
          id: empresa.id,
        };
      });
    },

    status() {
      return [
        { value: "DOCUMENTACAO_PENDENTE", label: "Pendente Documentação" },
        { value: "PENDENTE", label: "Pendente" },
        { value: "APROVADO", label: "Aprovado" },
        { value: "RECUSADO", label: "Recusado" },
        { value: "BLOQUEADO", label: "Bloqueado" },
        { value: "EXPIRADO", label: "Expirado" },
      ];
    },
    isEdit() {
      return !!this.$route.params.id;
    },
    canBlock() {
      return (
        !!this.$route.params.id &&
        this.form.dispositivo.status === "APROVADO" &&
        Util.isAdmin()
      );
    },
    canUnblock() {
      console.log(
        "CAN UNBLOCK:",
        this.form.dispositivo.status,
        this.$route.params.id,
        Util.isAdmin()
      );

      return (
        !!this.$route.params.id &&
        this.form.dispositivo.status === "BLOQUEADO" &&
        Util.isAdmin()
      );
    },
  },
});
</script>
